function betOutcomeNameFormatter(bet) {
  const patterns = ['[X]', '[Y]', '[Z]', '[Q]'];
  const parts = bet.specialValue.toString().split('|');
  let replaced = false;
  let formattedName = bet.betOutcome.betOutcomeDisplayName || bet.betOutcome.providerBetOutcomeId;

  _.each(parts, (part, i) => {
    const pattern = patterns[i];

    if (!_.includes(formattedName, pattern)) return;

    formattedName = _.replace(formattedName, pattern, part);
    replaced = true;
  });

  if (!replaced) {
    const sv = !bet.bet.betGroupingEnabled && bet.specialValue !== '*' ? `(${bet.specialValue})` : '';
    formattedName = `${formattedName} ${sv}`;
  }

  return formattedName;
}

export default {
  betOutcomeNameFormatter,
};
